;
define("cart_promocode_form.tpl", function(){});

